// eslint-disable-next-line import/no-anonymous-default-export
const fr = {
  descriptionBold: 'Nous nous réjouissons de votre intérêt.',
  description: 'Recherchez et sélectionnez le rendez-vous souhaité.',
  eventTypeTitles: {
    '': '',
    Youngster: 'Youngster (13 - 16 ans)',
	  'Job Info Events': 'Informations professionnelles',
	  Visits: 'Visites guidées',
    'Recruitment Days (1d)': 'Journées de recrutement (1 j)',
    'Recruitment Days (1d+)': 'Journées de recrutement (1 j+)',
    Internal: 'Interne',
  },
  noEvents: 'Pour le moment, il n\'y a pas de dates disponibles. Nous mettrons prochainement de nouvelles dates en ligne. Merci de votre patience.',
  loadError: 'Les dates n\'ont pas pu être chargées pour le moment. Veuillez recharger la page ou réessayer dans quelques minutes.',
  noGuidedTours: "Nous mettrons prochainement de nouvelles dates en ligne. Merci de votre patience. En attendant, vous pouvez nous contacter via le formulaire suivant: <1>Demande de visite guidée</1>",
  filters: {
    eventType: 'Changer le type d’événement',
    startDate: 'De',
    endDate: 'Jusqu\'à',
    location: 'Site',
    languageLabel: 'Langue',
    language: {
      title: 'Sélevtionnet la langue',
      en: 'Anglais',
      fr: 'Français',
      it: 'Italien',
      de: 'Allemand',
    },
    search: 'Recherche',
    clear: 'R\'einitialiser',
  },
  card: {
    startDate: 'Date de début :',
    startHour: 'Heure de début :',
    endDate: 'Date de fin :',
    endHour: 'Heure de fin :',
    until: 'jusqu\'à'
  },
  contact: 'Coordonnées',
  contactDesc: 'Pour toute question, composez le 043 931 61 11 ou envoyez un courriel à',
  feast: {
    title: 'Inscription au test FEAST 1',
    subtitle:
      "Les tests FEAST de Skyguide sont uniquement sur invitation et nécessitent une candidature préalable. Si ce n’est pas encore fait, veuillez postuler <1>ici</1> pour la formation correspondante de contrôleur aérien.",
    filterTitle: 'Recherchez et sélectionnez le rendez-vous requis.'
  },
  schoolOfCompetence: {
    title: 'School of Competence',
    subtitle: 'Découvrez les ateliers de la School of Competence de skyguide et inscrivez-vous à celui qui vous convient.',
    filterTitle: 'Recherchez et sélectionnez le rendez-vous requis.',
    filterLabel: 'School of Competence',
  },
};

export default fr;